import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ServiceCodeViewModel, SimpleServiceCode } from "../interfaces";
@Injectable()
export class ServiceCodeService
{
    private readonly $apiService = inject(ApiService);


    getAllServiceCodes(): Promise<ServiceCodeViewModel[]>
    {
        return this.$apiService.sendAuth("IServiceCodeService/GetAllServiceCodes");
    }

    getAllServiceCodesSimple(): Promise<SimpleServiceCode[]>
    {
        return this.$apiService.sendAuth("IServiceCodeService/GetAllServiceCodesSimple");
    }
}
